export const LANG = {
  JA: "ja",
  EN: "en",
};
